<template>
  <div>
    <DxPopup
      :visible="enabledPopUpFloor"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="auto"
      height="auto"
      :title="$t('registerProject.registerProjectGreenHouse.register_project_floor')"
    >
      <DxScrollView
        scroll-by-content
        scroll-by-thumb
        direction="both"
      >
        <div class="content-devx transparent">
          <DxForm
            :screen-by-width="screenByWidth"
            :min-col-width="240"
            label-location="left"
          >
            <DxGroupItem
              :col-count="1"
            >
              <DxSimpleItem
                :data-field="$t('registerProject.popPupFloor.nombre')"
                :editor-options="{
                  onValueChanged: onChangeName,
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :key="`texture_${key}`"
                :data-field="$t('registerProject.popPupFloor.textura')"
                editor-type="dxSelectBox"
                :editor-options="{
                  items: itemsTextures,
                  value: newFloor.texture_id,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  searchEnabled: true,
                  onValueChanged: onChangeTexture,
                  readOnly: false,
                  placeholder: ''
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :key="`clay_${key}`"
                :data-field="$t('registerProject.popPupFloor.arcilla')"
                :editor-options="{
                  value: newFloor.clay,
                  onValueChanged: onChangeClay,
                  readOnly: true
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :key="`sand_${key}`"
                :data-field="$t('registerProject.popPupFloor.arena')"
                :editor-options="{
                  value: newFloor.sand,
                  onValueChanged: onChangeSand,
                  readOnly: true
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :key="`silt_${key}`"
                :data-field="$t('registerProject.popPupTexture.limo')"
                :editor-options="{
                  value: newFloor.silt,
                  onValueChanged: onChangeSilt,
                  readOnly: true
                }"
              >
                <DxRequiredRule :message="$t('Field_Required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupFloor.profundidad')"
                editor-type="dxNumberBox"
                :editor-options="{
                  onValueChanged: onChangeDeep,
                  mode: 'number',
                }"
              >
                <DxLabel :text="$t('registerProject.popPupFloor.profundidad')" />
              </DxSimpleItem>
              <DxSimpleItem
                :data-field="$t('registerProject.popPupFloor.materia_organica')"
                editor-type="dxNumberBox"
                :editor-options="{
                  onValueChanged: onChangeMatter,
                  mode: 'number',
                }"
              />
              <DxSimpleItem
                :data-field="$t('registerProject.popPupFloor.carbonatos')"
                editor-type="dxNumberBox"
                :editor-options="{
                  onValueChanged: onChangeCarbonates,
                  mode: 'number',
                }"
              />
            </DxGroupItem>
          </DxForm>
        </div>
        <f7-block-footer>
          <div class="caption-text">
            <span class="note">
              Si no se conoce algún valor se carga por defecto el valor del suelo medio
            </span>
          </div>
          <div class="content-action-botton">
            <f7-button
              class="dx-btn-cancel margin-right"
              raised
              type="default"
              text-color="grey"
              styling-mode="outlined"
              name="ButtonCancel"
              @click="closePopUp"
            >
              {{ $t('EditOrder_ButtonCancel_caption') }}
            </f7-button>
            <f7-button
              :class="`dx-btn-success ${enabled ? '' : 'disabled'}`"
              raised
              type="success"
              styling-mode="contained"
              name="ButtonSave"
              @click="enabled ? followForm() : null"
            >
              {{ $t("EditOrder_ButtonSave_caption") }}
            </f7-button>
          </div>
        </f7-block-footer>
      </DxScrollView>
    </DxPopup>
    <DxPopUpTexture v-if="enabledPopUpFloor" />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import {
  DxForm, DxSimpleItem, DxGroupItem, DxRequiredRule,
  DxLabel,
} from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxPopUpTexture from '../registerProjectOpenAir/popUpTexture/index.vue';
import EventBus from '../../../js/event-bus';

export default {
  name: 'FloorFormPopUp',
  components: {
    DxPopup,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxPopUpTexture,
    DxScrollView,
    DxLabel,
  },
  data() {
    return {
      newFloor: {},
      key: 0,
      enabled: false,
      itemsTextures: [],
    };
  },
  computed: {
    ...mapState('ProjectGreenHouse', ['enabledPopUpFloor', 'typesFloor', 'newProject.floor', 'textures']),
  },
  async beforeMount() {
    try {
      EventBus.$on('create-database-texture', (data) => {
        if (data) {
          this.itemsTextures = this.textures.concat(this.typesFloor);
        }
      });
      EventBus.$on('setTypesFloor', this.setTypesFloor);
      EventBus.$on('selected-texture', (id) => {
        if (id) {
          for (const type of this.typesFloor) {
            if (id === type.id) {
              this.newFloor.texture = type;
            }
          }
          this.newFloor.texture_id = id;
          if (this.newFloor.texture) {
            this.newFloor.silt = this.newFloor.texture.silt;
            this.newFloor.clay = this.newFloor.texture.clay;
            this.newFloor.sand = this.newFloor.texture.sand;
            this.key += 1;
          }
          this.validate();
        }
      });
      await this.fetchDatabaseTexture();
      this.itemsTextures = this.textures.concat(this.typesFloor);
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.$f7.preloader.hide();
    }
  },
  beforeDestroy() {
    EventBus.$off('create-database-texture');
    EventBus.$off('selected-texture');
    EventBus.$off('setTypesFloor');
  },
  async mounted() {
    EventBus.$on('setTypesFloor', this.setTypesFloor);
    await this.fetchDatabaseTexture();
    this.itemsTextures = this.textures.concat(this.typesFloor);
  },
  methods: {
    validate() {
      this.enabled = !!(this.newFloor.name
          && this.newFloor.texture
          && this.newFloor.texture?.silt
          && this.newFloor.texture?.clay
          && this.newFloor.texture?.sand);
    },
    onChangeName(e) {
      this.newFloor.name = e.value;
      this.validate();
    },
    onChangeTexture(e) {
      if (e.value === 'Añadir') {
        this.setEnabledPopUpTexture(true);
        this.newFloor.texture_id = null;
        this.newFloor.silt = null;
        this.newFloor.clay = null;
        this.newFloor.sand = null;
        this.key += 1;
      } else {
        for (const type of this.typesFloor) {
          if (e.value === type.id) {
            this.newFloor.texture = type;
          }
        }
        this.newFloor.texture_id = e.value;
        if (this.newFloor.texture) {
          this.newFloor.silt = this.newFloor.texture.silt;
          this.newFloor.clay = this.newFloor.texture.clay;
          this.newFloor.sand = this.newFloor.texture.sand;
          this.key += 1;
        }
        this.validate();
      }
    },
    onChangeClay(e) {
      this.newFloor.clay = e.value;
      this.validate();
    },
    onChangeSand(e) {
      this.newFloor.sand = e.value;
      this.validate();
    },
    onChangeSilt(e) {
      this.newFloor.silt = e.value;
      this.validate();
    },
    onChangeDeep(e) {
      this.newFloor.root_deep = e.value;
      this.validate();
    },
    onChangeMatter(e) {
      this.newFloor.organic = e.value;
      this.validate();
    },
    onChangeCarbonates(e) {
      this.newFloor.carbonate = e.value;
      this.validate();
    },
    closePopUp() {
      this.onHidden();
    },
    async followForm() {
      try {
        this.$f7.preloader.show();
        if (!this.newFloor.root_deep) {
          this.newFloor.root_deep = 0.2;
        }
        if (!this.newFloor.carbonate) {
          this.newFloor.carbonate = 1;
        }
        if (!this.newFloor.organic) {
          this.newFloor.organic = 14;
        }
        await this.createDatabaseGround(this.newFloor);
        this.onHidden();
        this.newFloor.texture_id = null;
        this.newFloor.silt = null;
        this.newFloor.clay = null;
        this.newFloor.sand = null;
        this.key += 1;
      } catch (error) {
        this.setFloor('');
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onHidden() {
      this.setEnabledPopUpFloor(false);
    },
    setTypesFloor() {
      this.itemsTextures = this.textures.concat(this.typesFloor);
      this.key += 1;
    },
    screenByWidth(width) {
      return width < 720 ? 'sm' : 'md';
    },
    ...mapActions('ProjectGreenHouse', ['setEnabledPopUpFloor', 'createDatabaseGround', 'addElementoInFloor', 'setFloor', 'fetchDatabaseTexture']),
    ...mapActions('ProjectOpenAir', ['setEnabledPopUpTexture']),
  },
};
</script>
<style lang="scss" scoped>
@import "./popUpFloor";
@import "../../../css/mixins";
.caption-text {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 2rem 1rem;
}
.note {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  text-align: center;
  line-height: normal;
  color: steelblue;
  font-size: small;
  @include md {
    font-size: large;
    line-height: 28px;
  }
}
</style>
